import styled from 'styled-components';

import { useTranslation } from 'react-i18next';
import { IGlassesPackage } from '../../types';
import { breakpoints, colors } from '../../constants';
import { getQSVar, postDataLayerEvent } from '../../utils';

interface ITabProps {
    bgColor: string;
    selected: boolean;
}

const Tab = styled.h2.attrs({
    role: 'button',
})<ITabProps>`
    background-color: ${({ bgColor, selected }) =>
        selected ? bgColor : colors.white};
    padding: 10px 30px;
    cursor: pointer;
    font-weight: ${({ selected }) => (selected ? '700' : '400')};
    font-size: 1.6rem;
    color: ${({ selected }) => (selected ? colors.black : colors.grey)};
    transition: background-color 0.3s ease-in-out;

    @media (${breakpoints.mediumMin}) {
        padding: 20px 30px;
        font-size: 20px;
    }
`;

interface IProps {
    className?: string;
    selectedPackage: IGlassesPackage;
    showMultifocal: boolean;
    setShowMultifocal(value: boolean): void;
}

const BaseGlassesTypeSelector = ({
    className,
    selectedPackage,
    showMultifocal,
    setShowMultifocal,
}: IProps) => {
    const { t } = useTranslation();

    if (getQSVar('template')) return null;

    const handleGlassesTypeOptionClick = (multifocal: boolean) => {
        setShowMultifocal(multifocal);

        postDataLayerEvent(
            'A) Productkeuze: Klik glastype',
            multifocal ? t('multifocal') : t('single')
        );
    };

    return (
        <div className={className}>
            <Tab
                bgColor={selectedPackage.backgroundColorGeneral}
                selected={!showMultifocal}
                onClick={() => handleGlassesTypeOptionClick(false)}
            >
                {t('single')}
            </Tab>
            <Tab
                bgColor={selectedPackage.backgroundColorGeneral}
                selected={showMultifocal}
                onClick={() => handleGlassesTypeOptionClick(true)}
            >
                {t('multifocal')}
            </Tab>
        </div>
    );
};

export const GlassesTypeSelector = styled(BaseGlassesTypeSelector)`
    display: flex;
`;
